var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "inspections-page" } },
    [
      _c("add-inspection-modal", {
        ref: "addInspectionModal",
        on: {
          added: function($event) {
            _vm.$refs.dataTable.refresh()
          }
        }
      }),
      _c("update-inspection-pdf-modal", {
        ref: "updateInspectionPdfModal",
        on: {
          updated: function($event) {
            _vm.$refs.dataTable.refresh()
          }
        }
      }),
      _c("complete-inspection-modal", {
        ref: "completeInspectionModal",
        on: {
          updated: function($event) {
            _vm.$refs.dataTable.refresh()
          }
        }
      }),
      _c("inspection-timeline-modal", {
        ref: "inspectionTimelineModal",
        on: { commented: _vm.inspectionCommented }
      }),
      _vm.addInspectionsDialog.visible
        ? _c("addInspectionsDialog", {
            attrs: { "add-inspection-dialog": _vm.addInspectionsDialog },
            on: {
              close: function($event) {
                _vm.addInspectionsDialog.visible = false
              },
              added: function($event) {
                _vm.$refs.dataTable.refresh()
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row align-items-center justify-content-between" },
        [
          _c(
            "q-tabs",
            {
              attrs: { inverted: "" },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            _vm._l(_vm.tabs, function(value, key) {
              return _c("q-tab", {
                key: key,
                attrs: { slot: "title", name: key, label: value },
                slot: "title"
              })
            })
          ),
          _c("q-btn", {
            staticClass: "col-auto",
            attrs: {
              rounded: "",
              label: "Add Report",
              icon: "add",
              color: "primary",
              "no-caps": ""
            },
            on: { click: _vm.openAddModal }
          })
        ],
        1
      ),
      _c("q-btn", {
        staticClass: "mt-3",
        attrs: {
          size: "md",
          rounded: "",
          outline: "",
          color: "positive",
          icon: "mail",
          label: "Add Inspections from CSV"
        },
        nativeOn: {
          click: function($event) {
            _vm.addInspectionsDialog.visible = true
          }
        }
      }),
      _c("div", { staticClass: "mt-4 row full-row-exactly" }, [
        _c("div", { staticClass: "col-12 flex-1" }, [
          _c(
            "div",
            {
              staticClass: "gutter-sm",
              class:
                _vm.$q.screen.lt.md && !_vm.showFiltersMobile ? "column" : "row"
            },
            [
              _vm.$q.screen.lt.md || _vm.showFiltersDesktop
                ? _c(
                    "div",
                    {
                      class:
                        _vm.$q.screen.lt.md && !_vm.showFiltersMobile
                          ? "col-auto"
                          : "col-md-3"
                    },
                    [
                      _c(
                        "q-card",
                        { class: _vm.$q.screen.gt.sm ? "full-height" : "" },
                        [
                          _c("q-card-title", [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  Filters\n                "
                                )
                              ]),
                              _vm.$q.screen.lt.md
                                ? _c(
                                    "div",
                                    { staticClass: "col-auto q-mr-auto" },
                                    [
                                      _c("q-btn", {
                                        attrs: {
                                          color: "secondary",
                                          flat: "",
                                          round: "",
                                          icon:
                                            "keyboard_arrow_" +
                                            (_vm.showFiltersMobile
                                              ? "up"
                                              : "down")
                                        },
                                        on: { click: _vm.toggleFiltersMobile }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm.$q.screen.gt.sm || _vm.showFiltersMobile
                            ? _c(
                                "q-card-main",
                                {
                                  staticStyle: { height: "calc(100% - 64px)" }
                                },
                                [
                                  _c(
                                    _vm.$q.screen.gt.sm
                                      ? "q-scroll-area"
                                      : "div",
                                    {
                                      tag: "component",
                                      class: {
                                        "full-height": _vm.$q.screen.gt.sm
                                      }
                                    },
                                    [
                                      _c("bj-filters", {
                                        key: _vm.filtersResetReRenderKey,
                                        ref: "filtersModal",
                                        attrs: {
                                          fields: _vm.filterFields,
                                          types: _vm.$config.inspectionTypes,
                                          statuses: _vm.inProgressStates,
                                          "status-field-name": "state"
                                        },
                                        on: {
                                          reset: function($event) {
                                            _vm.filtersResetReRenderKey++
                                          },
                                          input: _vm.initFilters
                                        },
                                        model: {
                                          value: _vm.filters,
                                          callback: function($$v) {
                                            _vm.filters = $$v
                                          },
                                          expression: "filters"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _vm.columns
                    ? _c(
                        "bj-data-table",
                        {
                          ref: "dataTable",
                          staticClass: "full-height",
                          attrs: {
                            "filter-button": true,
                            columns: _vm.columns,
                            "with-add-button": false,
                            "single-name": "Report",
                            "quick-filters-container-class":
                              "" +
                              (_vm.selectedTab === "inProgress" ? "col" : ""),
                            "many-name":
                              (_vm.selectedTab === "inProgress"
                                ? "open"
                                : _vm.selectedTab) + " reports",
                            "with-total-count": true,
                            "with-cell-edit-button": false,
                            "with-cell-delete-button": false,
                            "with-actions-column": false,
                            "query-params": _vm.queryParams
                          },
                          on: {
                            "toggle-filters": _vm.toggleFiltersDesktop,
                            fetch: _vm.fetchConditionReports
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "cell-id",
                              fn: function(props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      ref: "td_id_" + props.row.id,
                                      class: [
                                        "d-flex p-0 m-0 w-100 h-100 align-items-center justify-content-center",
                                        _vm.dataLoading.value
                                          ? "disabled"
                                          : "cursor-pointer"
                                      ],
                                      on: {
                                        click: function($event) {
                                          _vm.dataLoading.value
                                            ? null
                                            : _vm.toggleDetails(props.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.row.id) +
                                          "\n                "
                                      ),
                                      _c("q-icon", {
                                        attrs: {
                                          size: "16px",
                                          name: "arrow_drop_down"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell-created_at",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("SdDatetime", {
                                    attrs: {
                                      value: row.created_at,
                                      "market-id":
                                        row.property && row.property.market_id,
                                      timezone:
                                        row.property && row.property.timezone
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell-completed_at",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("SdDatetime", {
                                    attrs: {
                                      value: row.completed_at,
                                      "market-id":
                                        row.property && row.property.market_id,
                                      timezone:
                                        row.property && row.property.timezone
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell-deleted_at",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("SdDatetime", {
                                    attrs: {
                                      value: row.deleted_at,
                                      "market-id":
                                        row.property && row.property.market_id,
                                      timezone:
                                        row.property && row.property.timezone
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell-state",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("inspection-state-dropdown", {
                                    ref: "state_" + row.id,
                                    attrs: { current: row.state },
                                    on: {
                                      change: function(state) {
                                        _vm.updateState(row, state)
                                      }
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell-type",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.capitalize(
                                          row.type.split("_").join(" ")
                                        )
                                      )
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "cell-business.name",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "capitalize",
                                      attrs: {
                                        to: {
                                          name: "app.businesses.profile",
                                          params: { id: row.business.id }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            row.business.name || row.business.id
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  row.associated_business_user
                                    ? _c("q-icon", {
                                        directives: [
                                          { name: "tippy", rawName: "v-tippy" }
                                        ],
                                        staticClass: "cursor-pointer",
                                        attrs: {
                                          name: "add",
                                          size: "15px",
                                          title:
                                            "Ordered by " +
                                            row.associated_business_user
                                              .full_name
                                        }
                                      })
                                    : _vm._e(),
                                  row.business.completed_inspections_count !==
                                    null &&
                                  row.business.completed_inspections_count <= 5
                                    ? _c(
                                        "q-chip",
                                        {
                                          staticClass: "d-block mt-2",
                                          attrs: {
                                            dense: "",
                                            color: "green",
                                            "text-color": "white"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                New Business\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell-property",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "app.properties.combined",
                                          params: { id: row.property_id }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(row.property.short_address) +
                                          "\n                "
                                      ),
                                      row.unit.name
                                        ? _c("span", [
                                            _vm._v(
                                              " | " + _vm._s(row.unit.name)
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell-preferred_from",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-auto" },
                                        [
                                          row.preferred_from
                                            ? _c("SdDatetime", {
                                                staticClass: "d-inline-flex",
                                                attrs: {
                                                  value: row.preferred_from,
                                                  "show-icon": false,
                                                  format: "MM/DD/YY h:mmA",
                                                  "market-id":
                                                    row.property &&
                                                    row.property.market_id,
                                                  timezone:
                                                    row.property &&
                                                    row.property.timezone,
                                                  until: row.preferred_until
                                                }
                                              })
                                            : row.unit_showing_profile_id
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                    Bundled with showing " +
                                                    _vm._s(
                                                      row.unit_showing_profile_id
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            : _c("span", [_vm._v("ASAP")]),
                                          _c(
                                            "inspection-schedule-date-picker",
                                            {
                                              attrs: {
                                                "preferred-from":
                                                  row.preferred_from,
                                                "preferred-until":
                                                  row.preferred_until,
                                                inspection: row
                                              },
                                              on: {
                                                "dates-updated": function(
                                                  dates
                                                ) {
                                                  return _vm.updatePreferredDates(
                                                    row,
                                                    dates
                                                  )
                                                }
                                              }
                                            }
                                          ),
                                          row.preferred_from ||
                                          row.preferred_until
                                            ? _c("q-icon", {
                                                staticClass:
                                                  "ml-1 cursor-pointer",
                                                attrs: {
                                                  name: "close",
                                                  size: "16px",
                                                  color: "primary"
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return (function() {
                                                      return _vm.clearPreferredDates(
                                                        row
                                                      )
                                                    })($event)
                                                  }
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell-agent",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c("select-inspection-agent", {
                                        staticClass: "float-left",
                                        staticStyle: { "min-width": "180px" },
                                        attrs: { inspection: row },
                                        on: {
                                          change: function(agent) {
                                            _vm.assignAgent(row, agent)
                                          }
                                        }
                                      }),
                                      row.assignment
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/app/agents/" +
                                                  row.assignment.user_id,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("q-btn", {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy"
                                                  }
                                                ],
                                                staticClass: "ml-3 mt-2 px-2",
                                                attrs: {
                                                  size: "sm",
                                                  outline: "",
                                                  color: "primary",
                                                  icon: "person",
                                                  title: "Agent Details"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell-last_update",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      row.recent_comment
                                        ? _c(
                                            "inspection-timeline-activity",
                                            {
                                              attrs: {
                                                inspection: row,
                                                activity: row.recent_comment
                                              }
                                            },
                                            [
                                              _c("SdDatetime", {
                                                attrs: {
                                                  value:
                                                    row.recent_comment
                                                      .created_at,
                                                  "market-id":
                                                    row.property.market_id,
                                                  timezone:
                                                    row.property.timezone
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("q-btn", {
                                        directives: [
                                          { name: "tippy", rawName: "v-tippy" }
                                        ],
                                        staticClass: "mr-0 ml-2",
                                        attrs: {
                                          size: "sm",
                                          rounded: "",
                                          outline: "",
                                          color: "primary",
                                          icon: "timeline",
                                          title: "Report Timeline"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.openTimelineModal(row)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell-follow_up_at",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      class: _vm.resolveFollowUpBackground(
                                        row.follow_up_at
                                      )
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-auto" },
                                        [
                                          row.follow_up_at
                                            ? _c("SdDatetime", {
                                                staticClass: "d-inline-flex",
                                                attrs: {
                                                  value: row.follow_up_at,
                                                  format: "MM/DD/YY",
                                                  "show-icon": false,
                                                  timezone: "UTC"
                                                }
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            [
                                              _c("q-icon", {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  name: "edit",
                                                  size: "16px",
                                                  color: "primary"
                                                }
                                              }),
                                              _c(
                                                "q-popup-edit",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center date-popedit",
                                                  on: {
                                                    show: function() {
                                                      return _vm.$refs[
                                                        "follow_up_at_" + row.id
                                                      ].show()
                                                    }
                                                  },
                                                  model: {
                                                    value: row.follow_up_at,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "follow_up_at",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "row.follow_up_at"
                                                  }
                                                },
                                                [
                                                  _c("q-datetime", {
                                                    ref:
                                                      "follow_up_at_" + row.id,
                                                    staticStyle: {
                                                      width: "180px"
                                                    },
                                                    attrs: {
                                                      clearable: "",
                                                      landscape: "",
                                                      "today-btn": "",
                                                      "emit-immediately": false,
                                                      "clear-value": null,
                                                      type: "date",
                                                      format: "MM/DD/YY"
                                                    },
                                                    on: {
                                                      input: function() {
                                                        return _vm.updateFollowUp(
                                                          row
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: row.follow_up_at,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          row,
                                                          "follow_up_at",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.follow_up_at"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      row.follow_up_at
                                        ? _c("q-icon", {
                                            staticClass: "ml-1 cursor-pointer",
                                            attrs: {
                                              name: "close",
                                              size: "16px",
                                              color: "primary"
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                return (function() {
                                                  return _vm.clearDateField(
                                                    row,
                                                    "follow_up_at"
                                                  )
                                                })($event)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell-happy_co_state",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("q-select", {
                                    attrs: { options: _vm.happyCoOptions },
                                    on: {
                                      input: function($event) {
                                        _vm.updateInspection(row, {
                                          happy_co_state: row.happy_co_state
                                        })
                                      }
                                    },
                                    model: {
                                      value: row.happy_co_state,
                                      callback: function($$v) {
                                        _vm.$set(row, "happy_co_state", $$v)
                                      },
                                      expression: "row.happy_co_state"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell-report",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  row.report_url
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "d-block",
                                          staticStyle: { "min-width": "127px" },
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.UrlFormatterUtil(
                                              row.report_url
                                            )
                                          }
                                        },
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              size: "sm",
                                              rounded: "",
                                              outline: "",
                                              color: "green",
                                              icon: "far fa-file-alt",
                                              label: "View Report"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("q-btn", {
                                    staticClass: "col-auto",
                                    attrs: {
                                      color: "green",
                                      outline: "",
                                      rounded: "",
                                      size: "sm",
                                      label: "Edit PDF",
                                      icon: "edit"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.openUpdateInspectionPdfModal(row)
                                      }
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell-price",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  row.price
                                    ? _c("span", [
                                        _vm._v("$" + _vm._s(row.price))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell-agent_payout",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  row.agent_payout
                                    ? _c("span", [
                                        _vm._v("$" + _vm._s(row.agent_payout))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell-transactions",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  !row.transactions.length
                                    ? _c("span", [_vm._v("-")])
                                    : _c(
                                        "span",
                                        _vm._l(row.transactions, function(
                                          transaction
                                        ) {
                                          return _c(
                                            "router-link",
                                            {
                                              key: transaction.id,
                                              staticClass: "q-mr-sm",
                                              attrs: {
                                                to: {
                                                  name: "app.transactions",
                                                  params: { id: transaction.id }
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "#" + _vm._s(transaction.id)
                                              )
                                            ]
                                          )
                                        })
                                      )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm.selectedTab === "inProgress"
                            ? _c(
                                "div",
                                {
                                  staticClass: "row",
                                  attrs: { slot: "quick-filters" },
                                  slot: "quick-filters"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col mr-4" },
                                    [
                                      _c("q-select", {
                                        attrs: {
                                          multiple: "",
                                          chips: true,
                                          options: _vm.inProgressStates,
                                          "float-label": "Select status"
                                        },
                                        on: { input: _vm.initFilters },
                                        model: {
                                          value: _vm.filters.state,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "state", $$v)
                                          },
                                          expression: "filters.state"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "col" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-column align-items-start min-width-300"
                                      },
                                      [
                                        _c(
                                          "q-toggle",
                                          {
                                            attrs: {
                                              value: "",
                                              label:
                                                "Upcoming unassigned reports",
                                              "false-value": 0,
                                              "true-value": 1
                                            },
                                            on: { input: _vm.initFilters },
                                            model: {
                                              value:
                                                _vm.filters.upcoming_unassigned,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "upcoming_unassigned",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.upcoming_unassigned"
                                            }
                                          },
                                          [
                                            _c(
                                              "q-tooltip",
                                              {
                                                staticStyle: {
                                                  "font-size": "14px"
                                                },
                                                attrs: {
                                                  anchor: "bottom middle",
                                                  self: "top middle"
                                                }
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  { staticClass: "p-3 m-0" },
                                                  [
                                                    _c("li", [
                                                      _vm._v(
                                                        "Ordered/scheduled statuses only"
                                                      )
                                                    ]),
                                                    _c("li", [
                                                      _vm._v(
                                                        "Scheduled for the next " +
                                                          _vm._s(
                                                            _vm.getAgentAssignableHoursBeforeInspection
                                                          ) +
                                                          " hours"
                                                      )
                                                    ]),
                                                    _c("li", [
                                                      _vm._v(
                                                        "No agent assigned yet"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c("q-btn-toggle", {
                                          staticClass: "mt-4",
                                          attrs: {
                                            "toggle-color": "primary",
                                            dense: true,
                                            options: [
                                              { label: "Off", value: "off" },
                                              {
                                                label: "HappyCo Assigned",
                                                value: "assigned"
                                              },
                                              {
                                                label: "HappyCo Unassigned",
                                                value: "unassigned"
                                              }
                                            ]
                                          },
                                          on: { input: _vm.initFilters },
                                          model: {
                                            value: _vm.filters.happy_co,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "happy_co",
                                                $$v
                                              )
                                            },
                                            expression: "filters.happy_co"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }